import Numpad from '../../../assets/numpad.svg';

const NumpadIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Numpad {...props} />;
};

export default NumpadIcon;
